<template>
  <div class="rent-bd tb">
    <div class="search-hd">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <!-- 操作项 -->
        <el-radio-group
          v-model="formSearch.dataType"
          @change="onPageChange({ page: 1 })"
        >
          <el-radio-button
            :label="item.value"
            v-for="(item, index) in dataType"
            :key="index"
          >{{ item.label }}</el-radio-button>
        </el-radio-group>
        <!-- 导出 -->
        <el-form-item
          style="float: right; margin-right: 0"
          v-if="funcView.receive_deposit_export_excel"
        >
          <el-button
            @click.native="exportTable"
            class="table-set"
            style="vertical-align: top"
          ><i class="icon icon-daochu"></i></el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item
          style="float: right"
          :class="{ 'mr-0': !(funcView.receive_deposit_export_excel) }"
        >
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input
            v-model="formSearch.search"
            :placeholder="$t('fms_receive_deposit.htbhjsh')"
            @fetch="onPageChange({ page: 1 })"
          ></search-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <!-- 应收押金 -->
      <custom-table
        key="1"
        v-if="formSearch.dataType == 1"
        :data="tableList"
        height="100%"
        tableCode="receiveDeposit"
        @column="setColumn"
        @sort="sortChange"
        @filter="filterChange"
        :filterArr="['refundState', 'receivableOrg', 'refundMethod', 'tradeTime', 'tradeAmount']"
        :slots="['action', 'payableOrg']"
      >
        <template
          slot="payableOrg"
          slot-scope="scope"
        >
          {{ scope.row.payableOrgName }}
        </template>
        <template
          slot="action"
          slot-scope="scope"
        >
          <span></span>
          <!-- 登记收款 -->
          <el-button
            type="text"
            size="mini"
            v-if="funcView.receive_deposit_register_collection && scope.row.billTradeState === 0 || scope.row.billTradeState === 1"
            @click.stop="registerCollection(scope.row, funcView.receive_deposit_register_collection)"
          >
            {{funcView.receive_deposit_register_collection}}
          </el-button>
          <!-- 确认收款 -->
          <el-button
            type="text"
            size="mini"
            v-if="funcView.receive_deposit_confirm_collection && scope.row.billTradeState === 6"
            @click.stop="confirmCollection(scope.row, funcView.receive_deposit_confirm_collection)"
          >
            {{funcView.receive_deposit_confirm_collection}}
          </el-button>
          <el-button
            type="text"
            size="mini"
            v-if="funcView.receive_deposit_check_collection && scope.row.billTradeState === 10"
            @click.stop="checkCollectionInfo(scope.row, funcView.receive_deposit_check_collection)"
          >
            {{funcView.receive_deposit_check_collection}}
          </el-button>
          <!-- 申请退款 -->
          <el-button
            type="text"
            size="mini"
            v-if="funcView.receive_deposit_apply_refund && scope.row.billTradeState === 10 && (scope.row.bizState === 45 || scope.row.bizState === 43)"
            @click.stop="onToRefund(scope.row)"
          >
            {{funcView.receive_deposit_apply_refund}}
          </el-button>
        </template>
      </custom-table>
      <!-- 退款中 -->
      <custom-table
        key="2"
        v-if="formSearch.dataType == 2"
        :data="tableList"
        height="100%"
        tableCode="receiveDeposit"
        @column="setColumn"
        @sort="sortChange"
        @filter="filterChange"
        :filterArr="['billTradeState', 'payableOrg', 'refundMethod', 'tradeTime', 'tradeAmount']"
        :slots="['action', 'receivableOrg']"
      >
        <template
          slot="receivableOrg"
          slot-scope="scope"
        >
          {{ scope.row.payableOrgName }}
        </template>
        <template
          slot="action"
          slot-scope="scope"
        >
          <span></span>
          <el-button
            type="text"
            size="mini"
            v-if="funcView.receive_deposit_return_register && scope.row.refundBillId"
            @click.stop="registrationRefund(scope.row, 'refund')"
          >
            <!-- 待确认退款：确认退款  其它为：退款登记 -->
            {{isWaitConfirm(scope.row) ? $t('fms_receive_deposit.que_ren_tui_kuan') : funcView.receive_deposit_return_register}}
          </el-button>
          <el-button
            v-if="funcView.receive_deposit_refund_detail"
            type="text"
            size="mini"
            @click.stop="onDepositRefund(scope.row)"
          >
            {{funcView.receive_deposit_refund_detail}}
          </el-button>
        </template>
      </custom-table>
      <!-- 退款成功 -->
      <custom-table
        key="3"
        v-if="formSearch.dataType == 3"
        :data="tableList"
        height="100%"
        tableCode="receiveDeposit"
        @column="setColumn"
        @sort="sortChange"
        @filter="filterChange"
        :filterArr="['billTradeState', 'payableOrg']"
        :slots="['action', 'receivableOrg']"
      >
        <template
          slot="receivableOrg"
          slot-scope="scope"
        >
          {{ scope.row.payableOrgName }}
        </template>
        <template
          slot="action"
          slot-scope="scope"
        >
          <span></span>
          <div v-if="funcView.receive_deposit_check_refund_record">
            <el-button
              type="text"
              size="mini"
              @click.stop="registrationRefund(scope.row, 'watch')"
            >
              {{funcView.receive_deposit_check_refund_record}}
            </el-button>
          </div>
        </template>
      </custom-table>
    </div>
    <div
      class="table-page"
      v-if="tableVisible"
    >
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
    <!--登记收款 -->
    <collection-registration-dialog
      :model="registerCollectionModel"
      v-if="registerCollectionVisible"
      @close="registerCollectionVisible = false"
      @success="getTableList"
      @toConfirm="onToConfirm"
    ></collection-registration-dialog>
    <!-- 查看收款信息 -->
    <check-collection-msg-dialog
      :model="collectionInfoModel"
      v-if="collectionInfoVisible"
      @close="collectionInfoVisible = false"
    ></check-collection-msg-dialog>

    <!-- 确认收款 -->
    <confirm-collection-dialog
      :model="confirmCollectionModel"
      v-if="confirmCollectionVisible"
      @close="confirmCollectionVisible = false"
      @success="getTableList"
    ></confirm-collection-dialog>
    <!-- 查看退款申请 -->
    <deposit-refund-detail-dialog
      v-if="dialogVisible2"
      :model="dialogModel2"
      @close="dialogVisible2 = false"
      @success="getTableList"
    ></deposit-refund-detail-dialog>
    <!-- 退款登记 / 查看退款记录 -->
    <deposit-registration-refund-dialog
      v-if="dialogVisible1"
      :model="dialogModel1"
      @close="dialogVisible1 = false"
      @success="getTableList"
    ></deposit-registration-refund-dialog>
    <!-- 申请退款（押金） -->
    <deposit-refund-dialog
      v-if="dialogVisible20"
      :model="dialogModel20"
      @close="dialogVisible20 = false"
      @success="getTableList"
    ></deposit-refund-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import commonMixin from '../mixins/commonMixin';
import depositRegistrationRefundDialog from '../components/deposit_registration_refund_dialog.vue';
import depositRefundDetailDialog from '../components/deposit_refund_detail_dialog.vue';
import depositRefundDialog from '../components/deposit_refund_dialog.vue';
import checkCollectionMsgDialog from '../components/accounts_collection_detail_dialog';
import confirmCollectionDialog from '../components/accounts_confirm_dialog.vue';
import collectionRegistrationDialog from '../components/accounts_registration_dialog';

// - 用于调试
const isMock = false;

export default {
  name: 'receiveDeposit',
  mixins: [commonMixin],
  components: { collectionRegistrationDialog, confirmCollectionDialog, checkCollectionMsgDialog, depositRegistrationRefundDialog, depositRefundDetailDialog, depositRefundDialog },
  data() {
    return {
      provide: true,
      formSearch: {
        type: 2,
        keyword: '',
        bodyNum: '',
        billPaymentTime: '',
        orderState: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,
        dataType: 1
      },
      tableList: [],
      totalRows: 0,

      dialogVisible: false,
      dialogModel: {},
      dialogVisible1: false,
      dialogModel1: {},
      dialogVisible2: false,
      dialogModel2: {},
      dialogVisible20: false,
      dialogModel20: {}
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    dataType() {
      const ret = [];
      if (this.funcView.receive_deposit_list) {
        ret.push({
          label: this.$t('fms_receive_deposit.ying_shou_ya_jin'),
          langCode: '',
          value: 1
        });
      }
      if (this.funcView.receive_deposit_returning_list) {
        ret.push({
          label: this.$t('fms_receive_deposit.tui_kuan_zhong'),
          langCode: '',
          value: 2
        });
      }
      if (this.funcView.receive_deposit_return_success) {
        ret.push({
          label: this.$t('fms_receive_deposit.tui_kuan_cheng_gong'),
          langCode: '',
          value: 3
        });
      }
      return ret;
    },
    tableVisible() {
      return this.funcView.receive_deposit_list || this.funcView.receive_deposit_returning_list || this.funcView.receive_deposit_return_success;
    }
  },
  mounted: function () {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getDicMap('bill_refund_state', () => {
      this.getTableList();
      this.getFuncView('/receive/deposit');
    });
  },
  methods: {
    // 判断是否为待确认退款状态
    isWaitConfirm(row) {
      const { refundState } = row;
      return `${refundState}` === `${this.dicMap.bill_refund_state.wait_confirmed}`;
    },
    // 退款登记, 查看退款记录  显示条件：row.refundBillId || row.billId
    registrationRefund(row, type) {
      const { refundBillId, billId } = row;
      if (refundBillId || billId) {
        this.dialogModel1 = {
          type,
          data: {
            billData: [row]
          },
          title: this.isWaitConfirm(row) ? this.$t('fms_receive_deposit.que_ren_tui_kuan') : this.funcView.receive_deposit_return_register
        };
        this.dialogVisible1 = true;
      } else {
        this.$message.error(
          this.$t('fms_receive_deposit.sjycqsgjzd')
        );
      }
    },
    // 申请退款（押金） 显示条件：无
    onToRefund(row) {
      this.dialogModel20 = {
        data: row,
        title: this.$t('fms_receive_deposit.shen_qing_tui_ya_jin')
      };
      this.dialogVisible20 = true;
    },
    // 查看退款申请  显示条件： refundBillId || billId
    onDepositRefund(row) {
      const { refundBillId, billId } = row;
      if (refundBillId || billId) {
        this.dialogModel2 = {
          data: {
            billData: [row]
          },
          title: this.$t('fms_receive_deposit.tui_kuan_deng_ji')
        };
        this.dialogVisible2 = true;
      } else {
        this.$message.error(
          this.$t('fms_receive_deposit.sjycqsgjzd')
        );
      }
    },
    // 确认收款
    onToConfirm({ billData, resData }) {
      this.confirmCollection(billData, this.$t('fms_receive_deposit.que_ren_shou_kuan'), resData);
    },
    // 导出
    exportTable() {
      const tableList = this.tableList;
      if (!tableList.length) {
        this.$message.error(
          this.$t('fms_receive_deposit.wsjkydc')
        );
        return;
      }
      this.$exportFlie(apis.depositExport, this.formSearch);
    },
    formatList(list) {
      list.forEach((item) => {
        if (isMock) {
          item.orderId = '';
          item.paymentCode = '';
          item.billPaymentCode = '';
          item.billPaymentId = '';
          item.paymentId = '';
          item.billId = '';
          item.changeId = '';
          item.refundBillId = '';
        }
      });
      return list;
    },
    // 获取表格数据
    getTableList: function () {
      const reqData = this.appendReqListData(this.formSearch, 'receive_deposit');
      this.$getJSON(apis.DepositPage, reqData).then((res) => {
        this.tableList = this.formatList(res.data.list || []);
        this.totalRows = res.data.total || null;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    }
  }
};
</script>

<style lang="scss"></style>
